import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_48a2b17b: FaireBrandEntity = {
  token: "b_48a2b17b",
  type: "brand",
  name: "Silk Road Bazaar",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb5a1300fc8d9780d1720ebbd1f86bd56dddf74cd986817a181d9c82552737a3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8ca8677764635a9c98dd81577a4b931da59f96cb8053968a92db951874fb5dec.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb5a1300fc8d9780d1720ebbd1f86bd56dddf74cd986817a181d9c82552737a3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8ca8677764635a9c98dd81577a4b931da59f96cb8053968a92db951874fb5dec.jpeg",
  location: "Montclair, NJ, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 618,
  isTopShop: true,
  isInsider: true,
  description:
    "Silk Road Bazaar is a wholesale representative of marginalized artist groups located in Central Asia. We connect with artists who are far from the capitals, who have limited market access, who do not possess modern marketable skills but have carried on traditional craft culture.\n\nFollowing the proverb, ‘the best way to know a man is to walk a thousand miles in his shoes,’ we believe that to know who we are working with and to understand their lives, we ourselves need to live like and with them. We live amongst our artist groups for an extended period of time. During that time we help them become self-sustainable by developing their designs, management techniques, quality control and computer skills.\n\nAll designs and collaborations are original works of Central Asian artists and Silk Road Bazaar.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:49.493Z",
    importedBy: "entity-db-cli",
  },
};
